import React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BarChartIcon from '@mui/icons-material/BarChart';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import GroupsIcon from '@mui/icons-material/Groups';
import HomeIcon from '@mui/icons-material/Home';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import InboxIcon from '@mui/icons-material/Inbox';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import MenuIcon from '@mui/icons-material/Menu';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import TvIcon from '@mui/icons-material/Tv';
import WavingHandIcon from '@mui/icons-material/WavingHand';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import HowToVoteIcon from '@mui/icons-material/HowToVote';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import LockIcon from '@mui/icons-material/Lock';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ZoomInIcon from '@mui/icons-material/ZoomIn';

/** Named icons used across the app — prefer these over raw emojis in UI chrome. */
export type AppIconName =
  | 'arrowBack'
  | 'barChart'
  | 'check'
  | 'close'
  | 'gamepad'
  | 'home'
  | 'hourglass'
  | 'howToVote'
  | 'inbox'
  | 'lightbulb'
  | 'lock'
  | 'menu'
  | 'openInNew'
  | 'people'
  | 'premium'
  | 'refresh'
  | 'search'
  | 'settings'
  | 'tag'
  | 'trendingUp'
  | 'tv'
  | 'warning'
  | 'wavingHand'
  | 'zoomIn';

const ICON_MAP = {
  arrowBack: ArrowBackIcon,
  barChart: BarChartIcon,
  check: CheckIcon,
  close: CloseIcon,
  gamepad: SportsEsportsIcon,
  home: HomeIcon,
  hourglass: HourglassEmptyIcon,
  howToVote: HowToVoteIcon,
  inbox: InboxIcon,
  lightbulb: LightbulbIcon,
  lock: LockIcon,
  menu: MenuIcon,
  openInNew: OpenInNewIcon,
  people: GroupsIcon,
  premium: WorkspacePremiumIcon,
  refresh: RefreshIcon,
  search: SearchIcon,
  settings: SettingsIcon,
  tag: LocalOfferIcon,
  trendingUp: TrendingUpIcon,
  tv: TvIcon,
  warning: WarningAmberIcon,
  wavingHand: WavingHandIcon,
  zoomIn: ZoomInIcon,
} as const;

export interface AppIconProps extends Omit<SvgIconProps, 'color'> {
  name: AppIconName;
}

export const AppIcon: React.FC<AppIconProps> = ({
  name,
  className,
  fontSize = 'inherit',
  ...props
}) => {
  const Icon = ICON_MAP[name];
  return (
    <Icon
      className={['app-icon', className].filter(Boolean).join(' ')}
      fontSize={fontSize}
      {...props}
    />
  );
};
